import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useCertificationAuthority,
  useFind: useCertificationAuthorities,
  useCreate: useCertificationAuthorityCreation,
  useUpdate: useCertificationAuthorityUpdate,
} = getCRUDHooks<{ id: number; name: string }>({
  entityName: 'certificationAutorities',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.certificationAuthorities,
});

export {
  useCertificationAuthority,
  useCertificationAuthorities,
  useCertificationAuthorityCreation,
  useCertificationAuthorityUpdate,
};
